module.exports = __webpack_public_path__ + "static/media/van.05acd9e1.svg";